import actionTypes from '../constants/action-types';

const blockHTML = (state = {}, action) => {
  if (action.type !== actionTypes.SET_BLOCK_HTML) return state;
  if (state.id !== action.payload.blockId) return state;

  return {
    ...state,
    html: action.payload.html,
  };
};

export default blockHTML;
